import _ from 'lodash';

import { get } from '@services';
import routes from '@configs/routes.json';
import {
  Order,
  OrderStatusType,
  SampleSummary,
  // OrderWithSamples,
} from '@models';

import {
  IOrdersAPI,
  IProcessingStatuses,
} from '../../components/results/components/ResultsTable/interfaces';

type SampleReportDTO = {
  id: string;
  reportNumber: string;
  reportType: 'CDx';
  status: 'Active' | 'Obsolete';
};

type OrderSampleDTO = {
  name: string;
  testId: string;
  subjectId: string;
  id: string;
  collectionDate: string | null;
  sampleType: 'ID' | 'MRD' | null;
  status: 'Uploaded' | 'Processing' | 'ProcessingWithWarning' | 'Finished';
  finishedDateTime: string;
  qcStatus: 'PASS' | 'FAIL' | 'CANCELLED' | 'PENDING';
  reports: SampleReportDTO[];
};

export type OrderDTO = {
  orderNumber: string;
  description: string;
  status: string;
  created: string;
  samples: OrderSampleDTO[];
};

const getSampleSummary = (samples: IProcessingStatuses[]): SampleSummary => {
  const statusesGrouped = _.groupBy(
    samples,
    (testSummary) => testSummary.status
  );
  const uploaded = statusesGrouped.Uploaded ?? [];
  const processing = statusesGrouped.Processing ?? [];
  const warnings = statusesGrouped.ProcessingWithWarning ?? [];
  const finished = statusesGrouped.Finished ?? [];
  const latestProcessedTest = _.maxBy(
    finished,
    (testStatus) => testStatus.finished
  );
  return {
    uploaded: uploaded.length,
    processing: processing.length + warnings.length,
    finished: finished.length,
    isProcessingWithWarning: warnings.length > 0,
    latestProcessed: latestProcessedTest
      ? new Date(latestProcessedTest.finished)
      : undefined,
  };
};

export const translateOrderDTO = (orders: IOrdersAPI[]): Order[] => {
  const format = orders.map(
    ({
      order: { orderNumber, description, status, created },
      processingStatuses: statuses,
    }) => {
      return {
        orderNumber: orderNumber,
        status: OrderStatusType[status as keyof typeof OrderStatusType],
        description: description ? description : '',
        created: new Date(created),
        sampleSummary: getSampleSummary(statuses),
      };
    }
  );
  return format;
};

// get order calls need better naming convention
// already have fix for this in seperate service branch
// export const getFullOrderDetails = async (): Promise<OrderWithSamples[]> => {
//   return get(routes.api.order.get).then((resp) => resp.json());
// };

export const getOrdersDetails = async (): Promise<any[]> => {
  return get(routes.api.order.get)
    .then((resp) => resp.json())
    .then(translateOrderDTO);
};

export const getSearchResults = async () => {
  return get(routes.api.ordertests.search)
    .then((response) => response.json())
    .then(translateOrderDTO);
};
